import React from 'react'
import BookMarkSVG from '../icons/bookMarkSVG'
import ClockSVG from '../icons/clockSVG'
import SecuritySVG from '../icons/securitySVG'

const Features = () => {
  return (
    <section id="features">
      <div className="pt-16 pb-8 md:pt-12 layout-space lg:pt-20 xl:pt-32 xl:pb-32">
        <div className=" md:text-center md:mb-16">
          <h2 className="mb-3 heading">Più di un'app di trascrizione</h2>
          <p className="mb-8 sub-heading">
            Le funzioni di produttività ti aiuteranno a lavorare usando le tue registrazioni e le tue trascrizioni per ottenere risultati sempre migliori.
          </p>
        </div>
        <div className="max-w-6xl mx-auto md:flex lg:px-10">
          <div className="max-w-sm px-4 mx-auto mb-6 text-center bg-white shadow-xl xl:px-8 rounded-xl md:mx-2 md:flex-1 blue-dot-after">
            <div className="pt-6 pb-4">
              <ClockSVG className="w-12 h-12 mx-auto" />
            </div>
            <h3 className="uppercase bold sub-heading">TRASCRIZIONE VIA EMAIL</h3>
            <h4 className="my-1 sub-heading text-accent bold">
              In pochi minuti
            </h4>
            <p className="pb-6 small">
              I tuoi memo vocali vengono trascritti e inviati automaticamente alla tua email in un istante
            </p>
          </div>
          <div className="max-w-sm px-4 mx-auto mb-6 text-center bg-white shadow-xl xl:px-8 rounded-xl md:mx-2 md:flex-1">
            <div className="pt-6 pb-4">
              <SecuritySVG className="w-12 h-12 mx-auto" />
            </div>
            <h3 className="uppercase bold sub-heading">SEMPRE SICURO</h3>
            <h4 className="my-1 sub-heading text-accent bold">Sempre sincronizzato</h4>
            <p className="pb-6 small">
              Tutte le riunioni, le tarscrizioni, gli appunti e i memo vocali vengono salvati sul tuo cloud (iCloud, Dropbox, Google Drive)
            </p>
          </div>
          <div className="max-w-sm px-4 mx-auto mb-6 text-center bg-white shadow-xl xl:px-8 rounded-xl md:mx-2 md:flex-1">
            <div className="pt-6 pb-4">
              <BookMarkSVG className="w-12 h-12 mx-auto" />
            </div>
            <h3 className="uppercase bold sub-heading">LEADER DEL SETTORE</h3>
            <h4 className="my-1 sub-heading text-accent bold">
              Trascrizione I.A.
            </h4>
            <p className="pb-6 small">
              La trascrizione umana richiede ore. Ottieni di più dalle tue interazioni e riunioni, lascia che sia VoxRec a trascrivere i tuoi dialoghi. .
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
export default Features
